import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { RootState } from "@lxp-app/store/store";
import Button from "@lxp-app/components/atoms/button";
import FaqQandACandidateComponent from "./faqQandA";
import { getFaqData } from "./faqQuesAndAnsData";
import FaqLoader from "@lxp-app/components/molecules/faq/faqLoader";
import { useTranslation } from "react-i18next";

interface DialogProps {
  setOpen: (val: boolean) => void;
}

const FaqQuestionAndAnswerModal = ({ setOpen }: DialogProps) => {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.UserInfoSlice);
  const hasAssessmentRecOrgs = user.profile.hasAssessmentRecOrgs;
  const faq = getFaqData(user.org, t);
  const [isFaqLoading, setIsFaqLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFaqLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className="w-full">
        <div className="mt-3 text-left">
          {/* {isFaqLoading ? (
            <FaqLoader/>
          ) : (
            <FaqQandACandidateComponent faqs={faq} />
          )}{" "} */}
          <FaqQandACandidateComponent
            faqs={faq}
            hasAssessmentRecOrgs={hasAssessmentRecOrgs}
          />
        </div>
      </div>
      <div className="mt-5 flex justify-end mb-5">
        <Button
          label={t("common.close")}
          variant="outlined"
          buttonColor="secondary"
          onClick={() => setOpen(false)}
          testId="closeModalBtn"
        />
      </div>
    </>
  );
};

export default FaqQuestionAndAnswerModal;
